import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { OfferBanner } from './components/OfferBanner';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedAttempts } from './components/FailedAttempts';
import { UniqueMethod } from './components/UniqueMethod';
import { WhatYouGet } from './components/WhatYouGet';
import { HowItWorks } from './components/HowItWorks';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { ProofSection } from './components/ProofSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { OfferBlock } from './components/OfferBlock';
import { Footer } from './components/Footer';
import { SocialProofNotification } from './components/SocialProofNotification';
import { ResultsSection } from './components/ResultsSection';
import { TrustSection } from './components/TrustSection';
import { MidPageCTA } from './components/MidPageCTA';
export function App() {
  useEffect(() => {
    document.title = 'Padres separados | Clave de paz';
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-offwhite font-sans text-slate-900 selection:bg-red-200 selection:text-red-900 pt-16 sm:pt-12" data-id="element-0">
      <OfferBanner data-id="element-1" />
      <SocialProofNotification data-id="element-2" />
      <HeroSection data-id="element-3" />
      <OpeningHook data-id="element-4" />
      <ResultsSection data-id="element-5" />
      <ProblemSection data-id="element-6" />
      <MidPageCTA data-id="element-7" />
      <FailedAttempts data-id="element-8" />
      <UniqueMethod data-id="element-9" />
      <WhatYouGet data-id="element-10" />
      <MidPageCTA data-id="element-11" />
      <HowItWorks data-id="element-12" />
      <WhoIsThisFor data-id="element-13" />
      <MidPageCTA data-id="element-14" />
      <ProofSection data-id="element-15" />
      <Testimonials data-id="element-16" />
      <TrustSection data-id="element-17" />
      <FAQSection data-id="element-18" />
      <OfferBlock data-id="element-19" />
      <Footer data-id="element-20" />
    </div>;
}